import Icon from '@ant-design/icons';
import type { CustomIconComponentProps } from '@ant-design/icons/lib/components/Icon';

const MeasurementOutlinedSvg = () => (
  <svg viewBox="0 0 24 24" width="1em" height="1em" fill="currentColor" transform="rotate(45)">
    <path d="M20.875 7H3.125C1.953 7 1 7.897 1 9v6c0 1.103.953 2 2.125 2h17.75C22.047 17 23 16.103 23 15V9c0-1.103-.953-2-2.125-2zm0 8H3.125c-.057 0-.096-.016-.113-.016-.007 0-.011.002-.012.008l-.012-5.946c.007-.01.052-.046.137-.046H5v3h2V9h2v4h2V9h2v3h2V9h2v4h2V9h1.875c.079.001.122.028.125.008l.012 5.946c-.007.01-.052.046-.137.046z"></path>
  </svg>
);

export const MeasurementOutlined = (props: Partial<CustomIconComponentProps>) => (
  <Icon component={MeasurementOutlinedSvg} {...props} />
);
